import React, { ReactElement } from 'react'
import { LanguageMyReportList } from '../../../../i18n'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
// Commons imports.

/**
 * Inline message for move all the existing reports to recycle bin prompt.
 *
 */
const PromptOverrideExistingReportsMessage: React.FC = (): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle('LanguageMyReportList')

    return <p className='padding-top'>{language?.get(LanguageMyReportList.ReportlistReportsKeptForThirtyDays)}</p>
}

export default PromptOverrideExistingReportsMessage
